import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import { DoubleAuthentificationForm } from "../schemas";
import {
  AuthResponse,
  DoubleAuthentificationResponse,
} from "@ac-expo/api-types";

const verify2Fa = async (data: DoubleAuthentificationForm) => {
  const { data: response } = await privateAxios.post<
    DoubleAuthentificationResponse | AuthResponse
  >(`/otp/verify`, data);
  return response;
};

export const useVerify2FaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: verify2Fa,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["generate-2fa"] });
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        throw {
          ...error,
          message: error.response?.data.message,
        };
      }
    },
  });
};
